webpackJsonp([129286796136351],{

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/AnshulJain.png";
	var icon2 = "https://winpeforum.com/assets/elements/KarishmaMakhija.png";
	var icon3 = "https://winpeforum.com/assets/elements/HarshaMundhada.png";
	var icon5 = "https://winpeforum.com/assets/elements/SaloniJhaveri.png";
	var icon6 = "https://winpeforum.com/assets/elements/ShivaniBhasin.png";
	var icon4 = "https://winpeforum.com/assets/elements/RemaSubramanian.jpg";
	var icon7 = "https://winpeforum.com/assets/elements/GautamMago.png";
	var icon8 = "https://winpeforum.com/assets/elements/Lizzie.png";
	var icon9 = "https://winpeforum.com/assets/elements/RuchiKhajanchi.png";
	var duration = 400;
	
	var I1 = "https://www.winpeforum.com/assets/sheshines/06nov2025/1.jpg";
	var I2 = "https://www.winpeforum.com/assets/sheshines/06nov2025/2.jpg";
	var I3 = "https://www.winpeforum.com/assets/sheshines/06nov2025/3.jpg";
	var I4 = "https://www.winpeforum.com/assets/sheshines/06nov2025/4.jpg";
	var I5 = "https://www.winpeforum.com/assets/sheshines/06nov2025/5.jpg";
	var I6 = "https://www.winpeforum.com/assets/sheshines/06nov2025/6.jpg";
	var I7 = "https://www.winpeforum.com/assets/sheshines/06nov2025/7.jpg";
	var I8 = "https://www.winpeforum.com/assets/sheshines/06nov2025/8.jpg";
	var I9 = "https://www.winpeforum.com/assets/sheshines/06nov2025/9.jpg";
	var I10 = "https://www.winpeforum.com/assets/sheshines/06nov2025/10.jpg";
	var I11 = "https://www.winpeforum.com/assets/sheshines/06nov2025/11.jpg";
	var I12 = "https://www.winpeforum.com/assets/sheshines/06nov2025/12.jpg";
	
	var II1 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/1.jpg";
	var II2 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/2.jpg";
	var II3 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/3.jpg";
	var II4 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/4.jpg";
	var II5 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/5.jpg";
	var II6 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/6.jpg";
	var II7 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/7.jpg";
	var II8 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/8.jpg";
	var II9 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/9.jpg";
	var II10 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/10.jpg";
	var II11 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/11.jpg";
	var II12 = "https://www.winpeforum.com/download.php?file=assets/sheshines/06nov2025/12.jpg";
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	
	    _this.Speaker1 = [{
	      imgUrl: icon1,
	      desc: "<div>\n          Anshul is a Managing Director and co-leads the investment team at Lighthouse Funds. She serves on the board of Duroflex. She was previously an investment banker with ICICI Securities.\n          <br/><Br/>\n          Anshul holds an MBA from Indian Institute of Management (IIM) Indore.\n          \n              </div>",
	      name: "Anshul Jain",
	      post: "<div>Managing Director<br/>\n          Lighthouse Funds\n          \n          </div>"
	    }, {
	      imgUrl: icon7,
	      desc: "<div>\n         Gautam is a founder and General Partner at A91 Partners; A91 is a growth investment firm founded in 2018 and has made ~30 investments so far. Previously, Gautam was a Managing Director at Sequoia Capital India and also worked at McKinsey & Company. He is an alumnus of IIM Calcutta and the University of Mumbai. He currently serves on the boards of Exotel, IntrCity, Inshorts, Kaar Technologies and Ummeed Housing Finance.\n\n              </div>",
	      name: "Gautam Mago",
	      post: "<div>Founder and General Partner<br/>\n        A91 Partners\n\n          </div>"
	    }, {
	      imgUrl: icon3,
	      desc: "<div>\n    Harsha has been a member of the Inflexor team since inception. She handles multiple responsibilities in the fund ranging from handling investor relations, managing deal execution & portfolio management to dealing with the various legal aspects of investing. As a Partner in the firm, she plays a pivotal role in the strategic as well as day to day operations of the firm.\n<br/><br/>\nPrior to joining Inflexor, Harsha has close to a decade of experience handling financial due diligence in M&A transactions across the Big4 firms like EY, PwC and Deloitte. Her keen insight into financial performance of companies gives her the unique ability to evaluate transactions.  \n<br/><br/>\nShe has a dual distinction of being a rank holder during her CA as well as MBA from IIM Ahmedabad. She is an active member of the Women in Investing communities in Mumbai. She enjoys spending time with her family, has interest in spirituality, early childhood education and collecting handloom sarees from various parts of India.\n </div>",
	      name: "Harsha Mundhadai",
	      post: "<div>Partner<br/> Inflexor\n \n            </div>"
	    }, {
	      imgUrl: icon2,
	      desc: "<div>\n      Karishma joined MOPE in 2021. She is responsible for transaction evaluation, financial analysis, deal documentation and portfolio management.\n<br/><br/>\nPrior to joining Motilal Oswal Private Equity, Ms. Makhija had over 11 years of experience in Investment Banking (Spark Capital, IIFL, HDFC Bank & KPMG) across Private equity, M&A & Capital Market fund raises. During her career, she has successfully executed transactions, some of the notable ones include private equity transactions in TransUnion CIBIL, India Shelter Finance and EssKay Finance, acquisition of Micro Housing Finance by Svatantra Microfinance & IPO of AU Financiers.\n<br/><br/>\nMs. Makhija holds a Bachelor's Degree in Commerce from NM College of Commerce and Economics, Mumbai and is a member of the Institute of Chartered Accountants of India.\n\n\n  \n        \n        </div>",
	      name: "Karishma Makhija",
	      post: "<div>Director - Investments<br/>Motilal Oswal Alternates\n\n         \n        </div>"
	    }, {
	      imgUrl: icon8,
	      desc: "<div>\n      Lizzie is a fintech leader and serial entrepreneur with over twenty years\u2019 experience across financial services, technology, and hospitality.\n<br/><Br/>\n\nShe co-founded ZestMoney, India\u2019s leading digital lending platform and an early innovator of \u201Cbuy now, pay later,\u201D raising over $120 million in equity and reaching $50 million in annual revenue. Lizzie also co-founded the Digital Lenders Association of India, advised the Government\u2019s Start-up Advisory Council, and served on the National Payments Corporation Innovation Council.\n<br/><br/>\n\nShe has founded and grown businesses in financial services, SaaS, hospitality, and wellness, holding non-executive director roles at Mahila Money, IndiaMart, and Cloud Nine.\n<br/><Br/>\n\nBeyond her commercial work, Lizzie is a passionate marathon runner, wine event organiser, actor, and writer.\n\n        </div>",
	      name: "Lizzie Chapman",
	      post: "<div>Fintech Leader and Serial Entrepreneur \n\n         \n        </div>"
	    }, {
	      imgUrl: icon4,
	      desc: "<div>\n          Rema has 4 decades experience in 0 to 1 and 1 to 10 stages of enterprises, founding a few, investing and in operational roles in others. Her career has been in category creating products and in future forward technology companies. Some of her notable experiences has been digitalization of financial service sector in early 90\u2019s to edtech at the start of internet to digitalization of SMB in late 80\u2019s.  Her experience extended to category creating product lines such as menswear to home water filters. This gave her the experience in forecasting tech use cases before it become mainstream and identifying business opportunities. Her hands on approach to nurture and help these businesses take root has been her main strength. She has helped businesses grow 20X on an average across the companies she has worked with.<br/><br/>\n          That also led to Ankur Capital.  The first decade+ of the millennium saw growth of mobile connectivity, highwayisation, retail activity along the newly built highways and a rapidly increasing aspirational population. At the sametime, India was seeing an increasing activity happening in biotech. Both Rema and Ritu strongly believed middle India was going be the next big opportunity with under penetrated sectors such as agtech, health and related sectors to be the next wave.<br/><br/>\n          She is a Cost and Management Accountant (AICWA), ICS, PGD in Systems Management. She is an active contributor to theeco-system as a member of the executive council of IVCA and IIC\n  \n          </div>",
	      name: "Rema Subramanian",
	      post: "<div>Managing Partner\n          <br/>\n          Ankur Capital Fund\n  \n   \n          </div>"
	    }, {
	      imgUrl: icon9,
	      desc: "<div>\n          Ruchi oversees finance, legal, tax, and investor reporting at A91 Partner. She has over 12 years\u2019 of transaction advisory experience at N.A. Shah Associates where she advised clients on several complex assignments including negotiation, vetting of legal documents, coordinating due diligence, tax and regulatory structuring, and transaction closing. She also has experience in fund raising, setting up of PE/VC funds (under SEBI AIF regulations) and has been involved in advising on M&A, business restructuring, cross border structuring, etc. She has worked with clients across various industries including technology, media, real estate, pharmaceuticals, logistics, etc..\n<br/><br/>\n\nRuchi started her career as a Business Leadership Trainee with Hindustan Unilever Limited.\n<br/><Br/>\n\nRuchi is a Chartered Accountant and achieved a 34th all India rank.\n\n  \n          </div>",
	      name: "Ruchi Khajanchi",
	      post: "<div>Chief Financial Officer<br/> A91 Partners\n\n   \n          </div>"
	    }, {
	      imgUrl: icon5,
	      desc: "<div>\n     Saloni has over two decades of experience in private equity, mergers and acquisitions, corporate finance, and strategy, having worked in the US and India. In her career, she has successfully negotiated, executed and closed several cross-border and domestic transactions involving mergers, acquisitions, joint ventures, private equity funding and entry-strategy assignments across sectors.\n<br/><br/>\nCurrently based in Mumbai, she joined NIIF in its early days as the Chief of Staff and was instrumental in building several pillars of the institution. She has played a pivotal role in establishing NIIF\u2019s offices, drafting the Governance Framework and Policies and Procedures for all the verticals of the firm, strategising for fund raising, chalking out the recruitment plan among others\n<br/><br/>\nShe currently heads Investor Relations and Partnerships at NIIF and is responsible for fund raising NIIF funds as well as building strong relationships with global investors, key stakeholders including Government of India representatives, global business leaders and Embassies and Consulates around the world. At NIIF, she has been responsible for successfully fundraising from several large, credible and reputed international and domestic investors.\n<br/><br/>\nPrior to joining NIIF, she was a Partner at SKP Business Consulting where she led a team of 15 in their M&A and Consulting practice. Saloni has also worked with KPMG India and HDFC Private equity. She started her career with Praxair in 1999, based out of their USA office.\n<br/><br/>\nSaloni holds a Bachelor\u2019s in Commerce and Master\u2019s in Commerce degree from Sydenham College of Commerce and Economics and an MBA from the Pennsylvania State University.\n\n </div>",
	      name: "Saloni Jhaveri",
	      post: "<div>Head - Investor Relations and Partnerships<br/> \nNIIF\n\n\n            </div>"
	    }, {
	      imgUrl: icon6,
	      desc: "<div>\n  Shivani Bhasin Sachdeva is the Founder & CEO of India Alternatives, a top-performing mid- market private equity firm investing in transformational themes in India, having over 22 years of global private equity experience in the US and in India. Shivani is considered a trailblazer in the industry as she is one of the first few women private equity founders in the country.\n<br/><br/>\nShivani has received multiple accolades and recognition for being one of the top women leaders in Finance in India, \u201CPrivate Equity Leader of the Year\u201D, at the WinPE Leadership Awards 2024, and the \u201CWomen First Award\u201D at the IVCA Alternate Capital Excellence Awards 2025. India Alternatives was recently awarded \u201CPrivate Equity Firm of the Year\u201D, at the Winpe Leadership Awards 2025.\n<br/><br/>\nShivani is a frequent speaker at domestic and international conferences on private equity and has also written numerous articles and spoken at various forums to promote gender equality. India Alternatives is committed to empowering women across its portfolio companies and the broader ecosystem and has undertaken various initiatives to propel women into leadership positions.\n<br/><br/>\nShivani received an MBA from the Wharton School, University of Pennsylvania and a B.A. in Economics from Mount Holyoke College (Phi-Beta-Kappa, Magna Cum Laude, Sarah Williston Scholar.)\n\n\n\n </div>",
	      name: "Shivani Bhasin Sachdeva ",
	      post: "<div>Founder & CEO<br/> India Alternatives\n\n\n\n            </div>"
	    }];
	
	    _this.Speaker2 = [{
	      imgUrl: icon2,
	      desc: "Alka Goel is the Founder of Alkemi Growth Capital LLP, an early stage healthcare and consumer wellness fund. She has led investment in multiple sub-sectors over the last 6 years. Prior to that, Alka was a Partner in McKinsey & Co., New York office, where she primarily served clients in the life science and private equity industry.\n<br/><br/>\nAt McKinsey, she served more than 350 Clients across all major geographies. She completed her business school from Indian Institute of Management, Ahmedabad in 2000 and Bachelor of Economics from Lady Shri Ram College, Delhi University.\n\n\n         ",
	      name: "Alka Goel",
	      post: "<div>Founding Partner<br/> Alkemi Growth Capital\n        </div>"
	    }];
	    _this.CollegiumsImages = [{ id: 23, ImgSrc: I1, ImgSrc1: II1 }, { id: 35, ImgSrc: I2, ImgSrc1: II2 }, { id: 22, ImgSrc: I3, ImgSrc1: II3 }, { id: 19, ImgSrc: I4, ImgSrc1: II4 }, { id: 35, ImgSrc: I5, ImgSrc1: II5 }, { id: 34, ImgSrc: I6, ImgSrc1: II6 }, { id: 23, ImgSrc: I7, ImgSrc1: II7 }, { id: 35, ImgSrc: I8, ImgSrc1: II8 }, { id: 22, ImgSrc: I9, ImgSrc1: II9 }, { id: 19, ImgSrc: I10, ImgSrc1: II10 }, { id: 35, ImgSrc: I11, ImgSrc1: II11 }, { id: 34, ImgSrc: I12, ImgSrc1: II12 }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "sheshines with Winpe",
	        image: "https://winpeforum.com/assets/elements/sheshineswebpage1.png",
	        description: "Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions! ",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                "Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "Winpe sheshines | November 6, 2025 @ A91 Partners"
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "date_heading" },
	              _react2.default.createElement(
	                "div",
	                { className: "date_heading" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  " Up Close with A91 Partners: Building a differentiated investment firm"
	                ),
	                " ",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "November 6, 2025 (5:00 - 8:00 PM IST)"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  " ",
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "A91 Partners Office, Mumbai "
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "center",
	              null,
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Hosted By:"
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("img", { src: "https://winpeforum.com/assets/elements/A91_Final.jpeg", style: { width: '60px' } }),
	              "   ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null)
	            ),
	            " ",
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { textAlign: 'justify' } },
	              "An engaging session exploring how to build a differentiated investment firm rooted in clarity of purpose, discipline, and integrity; followed by hosted table discussions where industry-leading senior women shared practical insights with participants investing with purpose, building investor relationships and balancing risks in venture portfolios. These discussions created a dynamic space for women from PEVC to exchange ideas and build meaningful connections. Hosted at the A91 Partners office, the event was a typical sheshines evening - filled with insightful conversations, practical learnings, and meaningful connections",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h2",
	                { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                "Event Highlights"
	              ),
	              "          ",
	              _react2.default.createElement("div", { "class": "r_btm" }),
	              "The evening started with a discussion with ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "Gautam Mago"
	              ),
	              ", Founder and General Partner, A91 Partners and ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "Ruchi Khajanchi"
	              ),
	              ", Chief Financial Officer, A91 Partners hosted with loads of wisdom and humor by ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "Lizzie Chapman"
	              ),
	              ", Fintech Leader and Serial Entrepreneur. The conversation used A91\u2019s stellar success as a base to delve into how clear vision, thoughtful strategy, and strong values are critical to build a differentiated investment firm and create enduring businesses. Hosted table discussions further enriched the evening, as speakers reflected on what sets seasoned investors apart\u2014underscoring the importance of pattern recognition, conviction, and the courage to back ideas ahead of their time.",
	              _react2.default.createElement("br", null),
	              " ",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "col-md-12" },
	                  _react2.default.createElement(
	                    "h2",
	                    { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                    "Hosted Table Speakers"
	                  ),
	                  "          ",
	                  _react2.default.createElement("div", { "class": "r_btm" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "Our_Speakers container" },
	                    _react2.default.createElement(
	                      "center",
	                      null,
	                      _react2.default.createElement(
	                        "div",
	                        { className: "Speakers_img", style: { width: '100%', margin: '0' } },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "row" },
	                          this.Speaker1.map(function (item, i) {
	                            if (i <= 10) {
	                              return _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "main_speaker_card col-md-4 col-sm-12 col-lg-4",
	                                  key: i
	                                },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "Scardd" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    {
	                                      className: "s_img",
	                                      onClick: function onClick() {
	                                        return _this3.togglePopUp(item);
	                                      }
	                                    },
	                                    _react2.default.createElement(
	                                      "center",
	                                      null,
	                                      "  ",
	                                      _react2.default.createElement("img", {
	                                        src: item.imgUrl,
	                                        alt: item.name,
	                                        className: "img-responsive",
	                                        style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                      })
	                                    )
	                                  ),
	                                  _react2.default.createElement("br", null),
	                                  "    ",
	                                  _react2.default.createElement("div", {
	                                    className: "Speakers_name",
	                                    dangerouslySetInnerHTML: { __html: item.name }
	                                  }),
	                                  _react2.default.createElement("div", {
	                                    className: "Speakers_post",
	                                    dangerouslySetInnerHTML: { __html: item.post }
	                                  })
	                                )
	                              );
	                            } else return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-3 col-sm-12 col-lg-3",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          })
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h2",
	                { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                "Key Takeaways "
	              ),
	              _react2.default.createElement("div", { "class": "r_btm" }),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Clarity of Investment Thesis:"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "A clear investment philosophy, sound judgment, and a deep understanding of founders, enabling disciplined decision-making across sectors."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Founder-Centric Approach:"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Identifying the right founders\u2014those with integrity, initiative, and strong execution capability\u2014as the foundation of every investment."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Long-Term Lens on Risk and Reward:"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Investment decisions guided by a long-term perspective, evaluating risk\u2013reward trade-offs thoughtfully rather than chasing short-term trends."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Focus on Profitability and Fundamentals:"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Strong unit economics and a clear path to profitability, with emphasis on building enduring businesses grounded in fundamentals, rather than chasing market momentum."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Value of Strategic Support:"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Offer operational expertise, mentorship, and access to networks that help companies scale effectively."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Purpose-Driven Investing:"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Embedding purpose\u2014through sustainability, community impact, and ethical governance\u2014has become a key differentiator, attracting talent, investors, and quality opportunities."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Balancing Vision and Discipline:"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "The art of venture investing lies in balancing bold vision with disciplined risk assessment, focusing on founder quality, adaptability, and market timing."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "b",
	                    null,
	                    "Trust, Alignment, and Diversity:"
	                  ),
	                  _react2.default.createElement("br", null),
	                  "Sustainable success is built on trust and long-term alignment between investors and founders. Diverse, gender-balanced teams enhance decision-making and firm culture, reinforcing these values."
	                )
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("hr", null),
	              _react2.default.createElement(
	                "i",
	                null,
	                "The evening concluded with a sense of inspiration and camaraderie, capturing the spirit of ",
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "sheshines"
	                ),
	                " \u2014 a platform for knowledge exchange, leadership conversations, and building meaningful connections within the PE\u2013VC ecosystem."
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "container" },
	              _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(_Heading2.default, { title: "Gallery" })
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                this.CollegiumsImages.map(function (item, j) {
	                  return _react2.default.createElement(
	                    "div",
	                    { className: "col-lg-4 col-md-4 col-sm-6 col-xs-12", style: { padding: '8px' } },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "img_card" },
	                      _react2.default.createElement("img", { style: { width: '100%' }, src: item.ImgSrc, alt: "Winpe sheshines" }),
	                      _react2.default.createElement(
	                        "a",
	                        { href: item.ImgSrc1 },
	                        " ",
	                        _react2.default.createElement("i", { style: { color: 'white', position: 'absolute', left: '20px', top: '20px' }, "class": "fa fa-2x  fa-download " })
	                      )
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null)
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sheshines-06-nov-2025-index-js-53feb85296b02344d6fd.js